"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _style = require("./style");

var _Typography = _interopRequireDefault(require("../Typography"));

var Paragraph = _Typography["default"].Paragraph,
    Text = _Typography["default"].Text;

function NoPermission(props) {
  var zIndex = props.zIndex,
      title = props.title,
      description = props.description;
  return /*#__PURE__*/_react["default"].createElement(_style.Container, {
    zIndex: zIndex
  }, /*#__PURE__*/_react["default"].createElement(_style.Content, null, title && /*#__PURE__*/_react["default"].createElement(Text, {
    size: "t5"
  }, title), description && /*#__PURE__*/_react["default"].createElement(Paragraph, {
    size: "md"
  }, description), /*#__PURE__*/_react["default"].createElement("img", {
    src: "https://static.ucloud.cn/1f2304abdc72ce9a9f6a4df0ca038824.png",
    width: 490,
    height: 154
  })));
}

NoPermission.propTypes = {
  /**
   * 背景层级设置， 默认是1000
   */
  zIndex: _propTypes["default"].number,

  /**
   * 标题
   */
  title: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * 描述
   */
  description: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].node])
};
NoPermission.defaultProps = {
  zIndex: 1000
};
var _default = NoPermission;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ui-components/lib/components/NoPermission/NoPermission.js
// module id = 2118
// module chunks = 6 7 17 18